// @ts-nocheck
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from '../../lib/routerAdapter';
import { navigate } from '../../lib/routerAdapter';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
import { accessTypeEnum, accessTypes } from './../../lib/enum';
import { Popconfirm, Icon, Operations, Table } from './../../components/ui';
import { Section } from './../../components/layout';
import Header from '../../components/layout/Header';
import { notificationLoading } from './../../components/Notifications';
import { fetchRoles } from '../../ducks/roles';
import { deleteRole } from '../../ducks/role';
const StyledIcon = styled(Icon).withConfig({
  displayName: "RoleList__StyledIcon",
  componentId: "sc-1mdsj4m-0"
})(["margin:0 5px;color:#1890ff;cursor:pointer;"]);
export class RoleList extends PureComponent {
  static defaultProps = {
    location: {},
    userAccess: []
  };
  state = {
    columns: [{
      title: '№',
      dataIndex: 'id',
      sorter: true,
      width: 50
    }, {
      title: 'Наименование',
      dataIndex: 'name',
      sorter: true
    }, {
      title: 'Доступы',
      dataIndex: 'access',
      render: access => access.map(accessItem => accessTypes[accessItem]).join(', ')
    }]
  };
  fetchRoles = async (page, orderBy, order) => await this.props.fetchRoles(page, {
    orderBy,
    byDescending: order === 'descend'
  });
  async deleteRole(id) {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await this.props.deleteRole(id);
      await this.fetchRoles(this.props.page);
      notification.success({
        message: 'Успешное удаление',
        description: `Роль с идентификатором ${id} была успешно удалена`
      });
    } catch (error) {
      notification.error({
        message: 'Ошибка при удалении',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  }
  componentDidMount() {
    const {
      columns
    } = this.state;
    if (this.canAdd()) {
      this.setState({
        columns: [...columns, {
          title: '',
          dataIndex: 'operations',
          width: 50,
          // eslint-disable-next-line no-unused-vars
          render: (text, role) => <Operations>
                <Popconfirm title="Вы действительно хотите удалить?" okText="Да" cancelText="Нет" onConfirm={() => this.deleteRole(role.id)}>
                  <StyledIcon type="x" />
                </Popconfirm>
              </Operations>
        }]
      });
    }
  }
  handleRowClick = id => navigate(`/admin/roles/${id}`);
  canAdd = () => this.props.userAccess.some(access => [accessTypeEnum.admin, accessTypeEnum.adminBranch, accessTypeEnum.handlingUsersAndRoles].includes(access));
  render() {
    const {
      roles,
      totalCount,
      pageSize,
      page,
      location
    } = this.props;
    const {
      columns
    } = this.state;
    const canAdd = this.canAdd();
    return <>
        <Header left={<h1>Роли</h1>} right={canAdd && <Link to="/admin/roles/new">
                <Button type="primary" data-cy="addRole">
                  Создать
                </Button>
              </Link>} />
        <Section>
          <Table onRow={record => ({
          onClick: () => this.handleRowClick(record.id)
        })} fetch={this.props.fetchRoles} fetchOnMount columns={columns} data={roles} rowKey="id" pagination={{
          page,
          pageSize,
          totalCount,
          location
        }} />
        </Section>
      </>;
  }
}
export default connect(state => ({
  userAccess: state.auth.profile.access,
  roles: state.roles.data,
  totalCount: state.roles.totalCount,
  pageSize: state.roles.pageSize,
  page: state.roles.page
}), {
  fetchRoles,
  deleteRole
})(RoleList);
